import get from 'lodash/get'
import intersection from 'lodash/intersection'

import { ROLE_LIST, ROLES as ROLE } from '../constants/roles'

const normalizeRoles = (roles = []) => (Array.isArray(roles) ? roles : [])

export const hasRoleAccess = (state, userRoles = []) => {
  const allowedRoles = get(state, 'data.roles', null)

  if (!allowedRoles || !Array.isArray(allowedRoles) || allowedRoles.length === 0) {
    return true
  }

  const normalizedUserRoles = normalizeRoles(userRoles)
  const normalizedAllowedRoles = normalizeRoles(allowedRoles)

  return intersection(normalizedUserRoles, normalizedAllowedRoles).length > 0
}

export const filterStatesByAccess = (states = [], userRoles = []) =>
  states.filter((state) => hasRoleAccess(state, userRoles))

export const findFirstAllowedStateName = (states = [], userRoles = []) => {
  const normalizedUserRoles = normalizeRoles(userRoles)

  const allowedState = filterStatesByAccess(states, normalizedUserRoles).find((state) => {
    const name = get(state, 'name', '')
    return name && name !== 'App' && name.startsWith('App')
  })

  return get(allowedState, 'name', null)
}

export const DEFAULT_ALLOWED_ROLES = ROLE_LIST

// Dashboard Config Role
export const DASHBOARD_ALLOWED_ROLES = [ROLE.PLATFORM_ADMIN,ROLE.MERCHANT_ADMIN,ROLE.MERCHANT_EDITOR]
export const DASHBOARD_REPORTS_ALLOWED_ROLES = [ROLE.PLATFORM_ADMIN,ROLE.MERCHANT_ADMIN]
// Ad Dashboard Config Role
export const ADDASHBOARD_ALLOWED_ROLES = [ROLE.PLATFORM_ADMIN,ROLE.AGENCY_ADMIN,ROLE.AGENCY_CAMPAIGN_MANAGER]
// Banners Config Role
export const BANNERS_ALLOWED_ROLES = [ROLE.PLATFORM_ADMIN,ROLE.AGENCY_ADMIN,ROLE.MERCHANT_ADMIN]
// Event Config Role
export const EVENTS_ALLOWED_ROLES = [ROLE.PLATFORM_ADMIN,ROLE.AGENCY_ADMIN,ROLE.MERCHANT_ADMIN]
// Setting Config Role
export const SETTING_BUSSINES_ALLOWED_ROLES = [ROLE.PLATFORM_ADMIN]
export const SETTING_USER_ALLOWED_ROLES = [ROLE.PLATFORM_ADMIN,ROLE.MERCHANT_ADMIN]
export const SETTING_CATALOGS_ALLOWED_ROLES = [ROLE.PLATFORM_ADMIN]

export default hasRoleAccess
